import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks";
import { verifyEmail } from "../actions/verify";
import { logout } from "../actions/auth";
import { Info } from "../../public/icons";
import { Btn } from "../styles/Button.styled";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { state, error, statusCode } = useAppSelector((s) => s.verifyEmail);

  const token = searchParams.get("token");
  const user = useAppSelector((s) => s.user);

  useEffect(() => {
    if (user.id === 0) {
      localStorage.setItem("redirectAfterLogin", location.pathname + location.search);
      navigate("/login", { replace: true });
      return;
    }
    if (token) {
      (dispatch as any)(verifyEmail(token));
    }
  }, [user.id, token]);

  useEffect(() => {
    if (state === "success") {
      const timer = setTimeout(() => navigate("/documents/all"), 2500);
      return () => clearTimeout(timer);
    }
  }, [state]);

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={{ ...iconWrapStyle, background: state === "failure" ? "color-mix(in srgb, var(--vivid-pink) 10%, transparent)" : "var(--sidebar-hover)" }}>
          <Info size={36} color={state === "failure" ? "var(--vivid-pink)" : "var(--blue)"} />
        </div>

        {state === "loading" && (
          <>
            <h2 style={titleStyle}>Верифікація...</h2>
            <p style={descStyle}>Перевіряємо ваш токен підтвердження.</p>
          </>
        )}

        {state === "success" && (
          <>
            <h2 style={titleStyle}>Адресу підтверджено!</h2>
            <p style={descStyle}>
              Ваша електронна адреса успішно верифікована.
              <br />
              Зараз вас буде перенаправлено до системи...
            </p>
          </>
        )}

        {state === "failure" && (
          <>
            <h2 style={{ ...titleStyle, color: "var(--vivid-pink)" }}>
              Помилка верифікації
            </h2>
            <p style={descStyle}>
              {error || "Посилання недійсне або термін його дії закінчився."}
            </p>
            {statusCode === 403 ? (
              <>
                <p style={descStyle}>
                  Невідповідність акаунта! Будь ласка, перевірте дані: поточний профіль не збігається з тим, який потрібно верифікувати.
                </p>
                <Btn type="button" $background="var(--blue)" $color="var(--white)" $width="100%" $marginTop="0" onClick={() => { (dispatch as any)(logout()); navigate("/login"); }}>
                  Вийти / Змінити акаунт
                </Btn>
              </>
            ) : (
              <Btn type="button" $background="var(--blue)" $color="var(--white)" $width="100%" $marginTop="0" onClick={() => navigate("/settings/account")}>
                Перейти до налаштувань
              </Btn>
            )}
          </>
        )}

        {!token && (
          <>
            <h2 style={{ ...titleStyle, color: "var(--vivid-pink)" }}>
              Токен відсутній
            </h2>
            <p style={descStyle}>Некоректне посилання для верифікації.</p>
            <Btn type="button" $background="var(--blue)" $color="var(--white)" $width="100%" $marginTop="0" onClick={() => navigate("/settings/account")}>
              Повернутись до системи
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}

const pageStyle: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "var(--background)",
};

const cardStyle: React.CSSProperties = {
  background: "var(--white)",
  borderRadius: "20px",
  padding: "48px 40px 40px",
  maxWidth: "420px",
  width: "90%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  textAlign: "center",
  boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
};

const iconWrapStyle: React.CSSProperties = {
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  background: "var(--sidebar-hover)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "4px",
};

const titleStyle: React.CSSProperties = {
  fontSize: "22px",
  fontWeight: 700,
  color: "var(--dark)",
  margin: 0,
};

const descStyle: React.CSSProperties = {
  fontSize: "14px",
  color: "var(--cadetGrey)",
  lineHeight: 1.6,
  margin: 0,
};

